export class Message {

  public text: string;
  public parent: string;

  constructor() {
  }

  setText(text: string) {
    this.text = text;
  }

  getText() {
    return this.text;
  }

  setParent(parent: string) {
    this.parent = parent;
  }

  getParent() {
    return this.parent;
  }

}
